<script>
import { Bar, mixins  } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'ViewingTimeNetworkChart',
  extends: Bar,
  mixins: [reactiveProp],
  data: function() {
    return {
      options:{
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    let label = data.datasets[tooltipItem.datasetIndex].label || '';
                    let value = tooltipItem.yLabel;
                    let unit = 's';
                    if (label) {
                        label += ': ';
                    }
                    /*if (value >= 3600) {
                      unit = 'H';
                      value = Math.round(value / 3600 * 10) / 10
                    } else if(value >= 60) {
                      unit = 'min';
                      value = Math.round(value / 60 * 10) / 10
                    }*/
                    if (value >= 3600) {
                        label = `${Math.round(value/3600)} H ${Math.round((value%3600)/60)} min`;
                    } else if (value < 3600) {
                        label = `${Math.round(value/60)} min ${Math.round((value%60))} s`;
                    }

                    //label += value + ' ' + unit;
                    return label;
                }
            }
        },
        scales: {
            xAxes: [{
                type: 'time',
                time: {
                  displayFormats:{
                    hour: 'DD/MM - H:mm',
                  },
                },
                distribution: 'series',
                stacked: true
            }],
            yAxes: [{
                stacked: true,
                ticks: {
                  min:0,
                    callback: function(inputValue, index, values) {
                      let label = '';
                      let value = inputValue;
                      let unit = 's';
                        if (label) {
                            label += ': ';
                        }
                        if (value >= 3600) {
                            unit = 'H';
                            value = Math.round(value / 3600 * 10) / 10
                        } else if(value >= 60) {
                            unit = 'min';
                            value = Math.round(value / 60 * 10) / 10
                        }

                        label += value + ' ' + unit;
                        return label;
                    }
                }
            }]
        },
        plugins: {
          datalabels: false,
          labels: false
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style>
</style>